import { useQuery } from "@tanstack/react-query";
import { SEO } from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { BlogCard } from "@/components/BlogsSection";
import { fetchBlogs } from "@/lib/api";

export default function Blogs() {
  const { data: blogs = [], isLoading } = useQuery({ queryKey: ["blogs"], queryFn: fetchBlogs });
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-32 sm:pt-36 pb-16 sm:pb-28" data-testid="blogs-page">
      <SEO
        title="Blogs by TruCitizen | India Mission 2047, Smart Cities & AI"
        description="Professional, fun-to-read explainers on India Mission 2047, India's smart cities and where India stands in the AI race. Written by TruCitizen."
        path="/blogs"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "TruCitizen Blog",
          url: `${window.location.origin}/blogs`,
          author: { "@type": "Organization", name: "TruCitizen" },
          blogPost: blogs.map((b) => ({ "@type": "BlogPosting", headline: b.title, url: `${window.location.origin}/blogs/${b.slug}`, image: b.cover_image, datePublished: b.created_at })),
        }}
      />
      <Reveal className="max-w-3xl mb-16">
        <p className="eyebrow mb-4">Blogs · Author: TruCitizen</p>
        <h1 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-[var(--ink)]">
          Read like a citizen who's paying attention.
        </h1>
        <p className="mt-6 text-base md:text-lg text-[var(--ink-soft)] leading-relaxed">
          Short, sharp, sourced reads on India — written by TruCitizen.
        </p>
      </Reveal>
      {isLoading ? (
        <div className="grid md:grid-cols-2 gap-6">{[0, 1, 2, 3].map((i) => <div key={i} className="h-96 rounded-3xl bg-white/50 animate-pulse" />)}</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-6">
          {blogs.map((b, i) => <BlogCard key={b.id} blog={b} index={i} featured={i === 0} />)}
        </div>
      )}
    </section>
  );
}
